import { ItemCard } from "@/components/ItemCard";
import { useModals } from "@/features/modals/hooks";
import { onDeleteOrder } from "@/features/orders/utils";
import { Text, Variables, crossIcon } from "@repo/skapa";
import { T, t } from "@repo/translation";
import { FlexDiv, useToast } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

export const NotFoundOrderItem = ({
  orderId,
  opportunityId,
}: {
  orderId: string;
  opportunityId?: number;
}) => {
  const { pushModal } = useModals();
  const { updateToast } = useToast();

  const menuItems = [
    {
      icon: crossIcon,
      title: t("action.remove_from_project"),
      onClick: () => {
        pushModal({
          type: "CONFIRM",

          onConfirm: () =>
            onDeleteOrder({
              opportunityId,
              orderId,
              updateToast,
            }),
          title: t("action.remove_from_project"),
          message: t("prompt.confirm_remove_order"),
        });
        trackAnalytics("remove_order_from_project");
      },
    },
  ];
  return (
    <ItemCard
      editable
      menuItems={menuItems}
      details={
        <FlexDiv flexDirection="column" width="100%" gap={Variables.space50}>
          <FlexDiv justifyContent="space-between">
            <Text textStyle="Heading.XS">
              <T translationKey="label.order" /> {orderId}
            </Text>
          </FlexDiv>

          <Text>
            <T translationKey="prompt.order_not_found" />
          </Text>
        </FlexDiv>
      }
    />
  );
};
